import { notify } from '@kyvg/vue3-notification'
import { UPLOADING_IMAGE_ATTR, removeInlineImages, stripRejectedImageMarks } from '../libs/editor-inline-image'
import { keepBlockLinksOnPaste } from '../libs/editor-paste-link'

export const useSummerNote = function (id, onButtonClick) {
  let menu = []
  let imageUploadEnabled = false

  /**
   * @param editorCallbacks 2026-10-20
   *   - onImageUpload (files) => void — 붙여넣은(또는 이미지 창에서 고른) 이미지 파일을 받는다.
   *     안 넘기면 섬머노트가 이미지를 base64(data:image…)로 본문에 그대로 박는다(글 한 건이 수 MB 가 되던 원인).
   *     업로드 메뉴가 없는 화면(업로드를 막은 게시판)에서는 걸지 않는다 — 그 화면에선 섬머노트가 base64 로 넣고, 아래 onChange 가 ✕ 로 바꾼다
   *   - onChange (contents, $editable) => void — 본문이 바뀔 때마다. 붙여넣은 base64 이미지를 파일로 올리거나(업로드 메뉴가 있는 화면)
   *     ✕ 로 바꾸는 데 쓴다(libs/editor-inline-image.ts). 어느 쪽인지는 canUploadImage() 로 가른다
   */
  function set(isAdmin, boardName, siteName, isDesignCustomized, defaultContentsHeight, editorCallbacks = {}) {
    const imageButton = function (context) {
      const ui = $.summernote.ui

      // create button
      const button = ui.button({
        contents: '<i class="note-icon-picture"/> 이미지 업로드',
        click() {
          onButtonClick()
        }
      })

      return button.render() // return button as jquery object
    }

    if (isAdmin) {
      menu = [
        // ['style', ['style']],
        ['font', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
        ['fontsize', ['fontsize']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['image', 'video', 'link', 'hr']],
        ['view', ['fullscreen', 'codeview']]
      ]
    } else {
      if (boardName === 'board_tutoring') { //자체 첨부파일로 파일 올리라고

      } else if (siteName === '도약아트' && boardName !== 'board_qna') { //도약아트에선 교육질문에서 업로드 못하게 하려고

      } else {
        menu = [
          ['insert', ['image', 'video']]
        ]
      }

    }

    const options = {
      placeholder: '내용을 작성 해 주세요',
      tabsize: 2,
      height: defaultContentsHeight,
      toolbar: menu,
      buttons: {
        image: imageButton
      },
      disableDragAndDrop: true,
      lang: 'ko-KR'
    }

    const { onImageUpload, onChange } = editorCallbacks
    options.callbacks = {}
    imageUploadEnabled = menu.some((group) => group[1]?.includes('image'))
    if (onImageUpload && imageUploadEnabled) options.callbacks.onImageUpload = onImageUpload
    if (onChange) options.callbacks.onChange = onChange
    // 2026-10-20 투어 카드처럼 «블록을 감싼 링크» 를 붙여넣으면 크롬이 <p> 줄에서 링크를 빈 껍데기로 쪼갠다 — 붙여넣기 직전에 그 줄만 <div> 로(libs/editor-paste-link.ts)
    options.callbacks.onPaste = (e) => keepBlockLinksOnPaste(e?.originalEvent, e?.target?.closest?.('.note-editable'))

    if (isDesignCustomized) {
      options.popover = {
        link: [
          ['link', ['linkDialogShow', 'unlink']]
        ],
        table: [
          ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
          ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
        ],
        air: [
          ['color', ['color']],
          ['font', ['bold', 'underline', 'clear']],
          ['para', ['ul', 'paragraph']],
          ['table', ['table']],
          ['insert', ['link', 'picture']]
        ]
      }
    }

    const $ = window.$
    if ($) {
      $('#' + id).summernote(options)
      // $('#' + id).on('summernote.change', function(we, contents, $editable) { 
      //   console.log('we',we);
      //   console.log('contents',contents);
      //   console.log('$editable',$editable);
      // });

      // $('#' + id).on('summernote.focus.codeview', function() {
      //   console.log('Codeview area enter focus');
      // });

      // $('#' + id).on('summernote.blur.codeview', function() {

      //   console.log('Codeview area loses focus');
      // });

      // $('#' + id).on('summernote.toggle.fullscreen', function() {
      //   console.log('풀스크린');
      // });
    }
  }

  /**
   * 2026-10-20 꺼내 가는 화면(게시판·관리자 폼 전부)이 저장하는 값 — 여기가 base64 의 마지막 관문이다.
   *  ✕ 표시(편집 화면용)를 빼고, 아직 파일로 못 올린 data 이미지도 뺀다(빼면 안내한다).
   *  붙여넣은 직후 1초 남짓 올리는 중에 저장을 누르면 그 이미지가 여기 걸린다 — 게시판은 isUploading() 으로 먼저 막는다
   */
  function getContents() {
    const code = stripRejectedImageMarks($('#' + id).summernote('code'))
    if (!code || code.indexOf('data:') === -1) return code
    const removed = removeInlineImages(code)
    if (!removed.count) return code
    notify({
      type: 'warn',
      text: removed.uploading
        ? '아직 올리는 중인 이미지는 저장에서 빠졌습니다. 업로드가 끝난 뒤 다시 저장해 주세요.'
        : '본문에 직접 들어간 이미지 데이터는 저장에서 빠졌습니다. 이미지는 이미지 업로드로 넣어 주세요.'
    })
    return removed.html
  }

  /** 업로드 메뉴가 있는 화면인가 — 붙여넣은 이미지를 자동으로 올려도 되는가(set() 뒤에 의미가 있다) */
  function canUploadImage() {
    return imageUploadEnabled
  }

  /** 붙여넣은 이미지를 올리는 중인가 — 저장 버튼에서 먼저 확인할 것 */
  function isUploading() {
    return !!document.getElementById(id)?.parentElement?.querySelector(`.note-editable img[${UPLOADING_IMAGE_ATTR}]`)
  }

  function setContents(content) {
    return $('#' + id).summernote('code', content)
  }

  function imageInsert(fileUrl) {
    console.log('imageInsert 호출됨 - id:', id, 'url:', fileUrl);
    
    // .note-editable 정확히 찾기
    const getEditableArea = () => {
      const summernoteContainer = document.getElementById(id);
      if (!summernoteContainer) return null;
      
      // summernote 구조: #id 다음 형제로 .note-editor가 있고, 그 안에 .note-editable이 있음
      let editor = summernoteContainer.nextElementSibling;
      if (editor && editor.classList.contains('note-editor')) {
        return editor.querySelector('.note-editable');
      }
      
      // 혹은 부모에서 찾기
      editor = summernoteContainer.closest('.summernote-wrapper')?.querySelector('.note-editor');
      if (editor) {
        return editor.querySelector('.note-editable');
      }
      
      return null;
    };
    
    // 파일명 추출 함수
    const getFileName = (url) => {
      const cleanUrl = url.split('?')[0].split('#')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    };
    
    const capturedTargetFileName = getFileName(fileUrl);
    
    console.log('summernote insertImage 실행');
    $('#' + id).summernote('insertImage', fileUrl)
    
    // 중복 체크 및 제거 (단일 타이머로 처리)
    setTimeout(() => {
      const editableArea = getEditableArea();
      
      if (editableArea) {
        const allImages = Array.from(editableArea.querySelectorAll('img'));
        console.log('600ms 후 - 전체 이미지 개수:', allImages.length);
        console.log('찾을 파일명 (캡처됨):', capturedTargetFileName);
        
        const matchingImages = allImages.filter(img => {
          const imgFileName = getFileName(img.src);
          console.log('비교:', imgFileName, '===', capturedTargetFileName, '?', imgFileName === capturedTargetFileName);
          return imgFileName === capturedTargetFileName;
        });
        
        console.log('매칭 이미지 개수:', matchingImages.length);
        
        // 2개 이상이면 중복 → 두 번째부터 모두 제거
        if (matchingImages.length >= 2) {
          console.log('중복 감지! 제거 시작');
          for (let i = 1; i < matchingImages.length; i++) {
            matchingImages[i].remove();
            console.log('중복 이미지 제거됨', i);
          }
        }
        // 0개여도 재삽입하지 않음 (이미 삽입했으므로)
      }
    }, 600); // 조금 더 여유있게 600ms

  }

  return {
    set,
    getContents,
    setContents,
    imageInsert,
    canUploadImage,
    isUploading
  }
}